import {useLayoutEffect} from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

am4core.useTheme(am4themes_animated);

const Chart4 = (props) => {

    useLayoutEffect(() => {
        am4core.useTheme(am4themes_animated);
        // let pieData = chartData && chartData;
        let donutLow = props?.low;
        let donutInRange = props?.inrange;
        let donutHigh = props?.high;
        var chart = am4core.create('chartdiv', am4charts.PieChart);

        // Add data
        chart.data = [
            {
                category: 'Low(<70)',
                value: donutLow,
            },
            {
                category: 'InRange(70-180)',
                value: donutInRange,
            },
            {
                category: 'High(>180)',
                value: donutHigh,
            },
        ];

        // Add and configure Series
        var pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = 'value';
        pieSeries.dataFields.category = 'category';

        // Let's cut a hole in our Pie chart the size of 40% the radius
        chart.innerRadius = am4core.percent(40);

        // Set up fills
        pieSeries.slices.template.fillOpacity = 1;

        var hs = pieSeries.slices.template.states.getKey('hover');
        hs.properties.scale = 1;
        // hs.properties.fillOpacity = 0.5;

        pieSeries.colors.list = [
            am4core.color('#D81D5D'),
            am4core.color('#3BBA4C'),
            am4core.color('#FEB140'),
        ];

        pieSeries.tooltip.disabled = true;
        pieSeries.ticks.template.disabled = true;
        pieSeries.alignLabels = false;
        // pieSeries.labels.template.relativeRotation = 90;
        pieSeries.labels.template.text = "{value.percent.formatNumber('#.')}%";
        pieSeries.labels.template.radius = am4core.percent(-25);
        pieSeries.labels.template.fill = am4core.color('white');
        pieSeries.labels.template.fill = am4core.color('white');
        pieSeries.labels.template.adapter.add('radius', function (radius, target) {
            if (target.dataItem && target.dataItem.values.value.percent <= 4) {
                return 0;
            }
            return radius;
        });

        pieSeries.labels.template.adapter.add('fill', function (color, target) {
            if (target.dataItem && target.dataItem.values.value.percent < 5) {
                return am4core.color('white');
            }
            return color;
        });

        pieSeries.labels.template.adapter.add('fill', function (color, target) {
            if (target.dataItem && target.dataItem.values.value.percent <= 4) {
                return am4core.color('gray');
            }
            return color;
        });

        pieSeries.ticks.template.events.on('ready', hideSmall);
        pieSeries.ticks.template.events.on('visibilitychanged', hideSmall);
        pieSeries.labels.template.events.on('ready', hideSmall);
        pieSeries.labels.template.events.on('visibilitychanged', hideSmall);

        function hideSmall(ev) {
            if (ev.target.dataItem && ev.target.dataItem.values.value.percent === 0) {
                ev.target.hide();
            } else {
                ev.target.show();
            }
        }

        chart.current = chart;
        pieSeries.hiddenState.properties.opacity = 1;
        pieSeries.hiddenState.properties.endAngle = -90;
        pieSeries.hiddenState.properties.startAngle = -90;
        return () => {
            chart.dispose();
        };
    }, [props]);

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
            }}
        >
            <div
                dir='ltr'
                id='chartdiv'
                style={{
                    width: '300px',
                    height: '350px',
                    margin: 'auto',
                }}
            />
        </div>
    );
};

export default Chart4;
